// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","187":"NotFound","443":"about","548":"calendar","631":"contact","821":"pagina"}[chunkId] || chunkId) + "-legacy." + {"177":"4ad21adc","181":"f0a492aa","187":"5cbdafc5","240":"ec7df909","443":"5ccdc6b1","548":"33f2d0fc","581":"21d84871","631":"33e9137f","821":"fe5c5072"}[chunkId] + ".js";
};